import React from 'react';
import 'ag-grid-community/styles/ag-grid.css'; // Core CSS
import 'ag-grid-community/styles/ag-theme-alpine.css'; // Theme CSS
import DataTable from 'components/data-table/DataTable';

const doctorsData = [
    {
        sno: 1,
        name: "Yash Pathalogy",
        contact: "+91 98765 43210",
        city: "Indore",
        country: "India",
        subscriptionPlan: "Enterprise",
        purchaseDate: "2024-01-15",
        expireDate: "2025-01-15",
        daysLeft: 365,
    },
    {
        sno: 2,
        name: "Apollo Pathology",
        contact: "+91 98675 23456",
        city: "Delhi",
        country: "India",
        subscriptionPlan: "Standard",
        purchaseDate: "2023-12-01",
        expireDate: "2024-12-01",
        daysLeft: 320,
    },
    {
        sno: 3,
        name: "SR Pathology",
        contact: "+91 91234 56789",
        city: "Indore",
        country: "India",
        subscriptionPlan: "Basic",
        purchaseDate: "2023-10-10",
        expireDate: "2024-10-10",
        daysLeft: 270,
    },
    {
        sno: 4,
        name: "Sampurna Pathology",
        contact: "+91 99876 54321",
        city: "Indore",
        country: "India",
        subscriptionPlan: "Premium",
        purchaseDate: "2023-05-20",
        expireDate: "2024-05-20",
        daysLeft: 80,
    },
    {
        sno: 5,
        name: "Metropolis Pathology",
        contact: "+91 97531 24680",
        city: "Indore",
        country: "India",
        subscriptionPlan: "Standard",
        purchaseDate: "2024-02-12",
        expireDate: "2025-02-12",
        daysLeft: 400,
    },
    {
        sno: 6,
        name: "Navin Pathology",
        contact: "+91 98234 78901",
        city: "Indore",
        country: "India",
        subscriptionPlan: "Basic",
        purchaseDate: "2023-08-18",
        expireDate: "2024-08-18",
        daysLeft: 180,
    },
    {
        sno: 7,
        name: "Central Lab Pathology",
        contact: "+91 93456 78912",
        city: "Indore",
        country: "India",
        subscriptionPlan: "Premium",
        purchaseDate: "2023-11-25",
        expireDate: "2024-11-25",
        daysLeft: 330,
    },
    {
        sno: 8,
        name: "Lupin Diagnostics",
        contact: "+91 91234 98123",
        city: "Indore",
        country: "India",
        subscriptionPlan: "Standard",
        purchaseDate: "2023-03-10",
        expireDate: "2024-03-10",
        daysLeft: 30,
    },
    {
        sno: 9,
        name: "Apex Diagnostics",
        contact: "+91 98712 34567",
        city: "Indore",
        country: "India",
        subscriptionPlan: "Basic",
        purchaseDate: "2023-07-05",
        expireDate: "2024-07-05",
        daysLeft: 120,
    },
  
];


const columnDefs = [
    { headerName: "S.No", field: "sno", sortable: true, filter: true },
    { headerName: "Name", field: "name", sortable: true, filter: true },
    // { headerName: "Contact", field: "contact", sortable: true, filter: true },
    { headerName: "City", field: "city", sortable: true, filter: true },
    // { headerName: "Country", field: "country", sortable: true, filter: true },
    { headerName: "Subscription Plan", field: "subscriptionPlan", sortable: true, filter: true },
    { headerName: "Purchase Date", field: "purchaseDate", sortable: true, filter: true },
    { headerName: "Expire Date", field: "expireDate", sortable: true, filter: true },
    { headerName: "Days Left", field: "daysLeft", sortable: true, filter: true },
];

const DoctorTable = () => {
    return (
        <div className='mt-3'>

            <DataTable
                rowData={doctorsData}
                columnDefs={columnDefs}
            />
        </div>
    );
};

export default DoctorTable;
